export default String.raw`
{% assign data = include -%}
{% include 'partials/textField/textField.html' with data -%}
`